import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCalendarStart = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	color: "#0f1826",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M2.36667 3.23334H13.6333C13.6333 3.23334 14.5 3.23334 14.5 4.1V13.6333C14.5 13.6333 14.5 14.5 13.6333 14.5H2.36667C2.36667 14.5 1.5 14.5 1.5 13.6333V4.1C1.5 4.1 1.5 3.23334 2.36667 3.23334Z",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1.5 6.70001H14.5",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.9668 4.53333V1.5",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.0334 4.53333V1.5",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.74487 12.536L10.6349 10.646L8.74487 8.75597",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.65217 10.646L5.36548 10.646",
			stroke: "currentColor",
			strokeLinecap: "round"
		})
	]
});
export default SvgCalendarStart;
